import { render, staticRenderFns } from "./ListMeetings.vue?vue&type=template&id=a4855a68&"
import script from "./ListMeetings.vue?vue&type=script&lang=js&"
export * from "./ListMeetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports